import {
  Add,
  Bag2,
  HambergerMenu,
  LogoutCurve,
  UserSquare,
} from 'iconsax-react';
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useShallow } from 'zustand/shallow';
import logo from '../../../../assets/images/logo.webp';
import Text from '../../../../assets/styles/Text';
import { useStore } from '../../../../stores';
import { cartStore } from '../../../../stores/cartStore';
import Cart from '../../../Cart';
import * as styles from './styles';

export default function LinkMobile() {
  const [show, setShow] = useState(false);

  const { logout, user } = useStore(
    useShallow((state) => ({
      logout: state.logout,
      user: state.user,
    }))
  );
  const { showCart, openCart } = cartStore();

  function handleMenuShow() {
    setShow((prev) => !prev);
  }

  if (!user) {
    return (
      <styles.Container className="mobile">
        <styles.ButtonLink onClick={handleMenuShow}>
          <HambergerMenu />
        </styles.ButtonLink>

        {show && (
          <styles.Menu>
            <div>
              <img src={logo} alt="logo" />
              <button type="button" onClick={() => setShow(false)}>
                <Add />
              </button>
            </div>

            <Link to="/modellogin" onClick={() => setShow(false)}>
              <Text.Span>Entrar como modelo</Text.Span>
            </Link>

            <Link to="/modelregister" onClick={() => setShow(false)}>
              <Text.Span>Quero ser acompanhante</Text.Span>
            </Link>

            <Link to="/clientlogin" onClick={() => setShow(false)}>
              <Text.Span>Entrar como cliente</Text.Span>
            </Link>

            <Link to="/clientregister" onClick={() => setShow(false)}>
              <Text.Span>Quero ser cliente</Text.Span>
            </Link>
          </styles.Menu>
        )}
      </styles.Container>
    );
  }

  return (
    <styles.Container className="mobile">
      <Cart show={showCart} />

      <button type="button" onClick={logout}>
        <LogoutCurve size={26} />
      </button>

      {user?.type === 'model' && (
        <button type="button" onClick={openCart}>
          <Bag2 size={26} />
        </button>
      )}
      <Link to={`/${user?.type}dashboard`}>
        <UserSquare size={26} />
      </Link>
    </styles.Container>
  );
}
